(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveal
  var reveals = document.querySelectorAll('.ev-reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var d = e.target.getAttribute('data-ev-delay') || 0;
          e.target.style.transitionDelay = (d * 90) + 'ms';
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '-40px' });
    reveals.forEach(function (el) { io.observe(el); });
  }

  // Scatter the gold particles
  var motes = document.querySelectorAll('.ev-mote');
  motes.forEach(function (m, i) {
    m.style.left = ((i * 37) % 100) + '%';
    m.style.top = ((i * 53 + 11) % 96) + '%';
    m.style.animationDelay = ((i % 8) * 0.9) + 's';
    m.style.animationDuration = (9 + (i % 6) * 2) + 's';
  });

  // Hero cursor parallax (fine pointers only)
  if (!reduce && window.matchMedia('(pointer: fine)').matches) {
    var stage = document.querySelector('[data-ev-parallax]');
    if (stage) {
      var layers = stage.querySelectorAll('[data-depth]');
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = 0;
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!raf) raf = requestAnimationFrame(tick);
      });
      function tick() {
        cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
        layers.forEach(function (l) {
          var d = parseFloat(l.getAttribute('data-depth')) || 0;
          l.style.transform = 'translate3d(' + (cx * d * 26) + 'px,' + (cy * d * 26) + 'px,0)';
        });
        if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) { raf = requestAnimationFrame(tick); }
        else { raf = 0; }
      }
    }
  }

  // Robust autoplay for hero videos (some browsers block muted autoplay until interaction)
  var heroVideos = document.querySelectorAll('video.ev-hero__bgvideo');
  if (heroVideos.length && !reduce) {
    heroVideos.forEach(function (dv) {
      dv.muted = true; dv.setAttribute('muted','');
      var tryPlay = function () { var p = dv.play(); if (p && p.catch) p.catch(function(){}); };
      tryPlay();
      document.addEventListener('DOMContentLoaded', tryPlay);
      ['scroll','touchstart','pointerdown','click','keydown'].forEach(function (ev) {
        window.addEventListener(ev, tryPlay, { once: true, passive: true });
      });
    });
  }
})();